import { ConditionType } from '../../types'
import BaseCondition from '../BaseCondition'

export default abstract class LabelCondition extends BaseCondition {
  abstract type: ConditionType.HasLabel | ConditionType.HasNotLabel

  label_index!: number | null
}
